"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStateNodeByStatus = exports.getStateNodeByStatus = exports.getStatusPath = void 0;
const react_1 = require("react");
const workflow_core_1 = require("@sierralabs/workflow-core");
/**
 * Replace old `rootNode` from status if it does not match.
 */
function getStatusPath(status, workflow) {
    if (typeof status === 'undefined' || !workflow) {
        return status;
    }
    // prepend rootNode to status value if it does not match
    const rootNode = `/${workflow.stateNode.name}/`;
    const taskStatus = status.startsWith(rootNode)
        ? status
        : rootNode + (0, workflow_core_1.parseTaskStatus)(status);
    return taskStatus;
}
exports.getStatusPath = getStatusPath;
/**
 * Get StateNode based on `task.status` (wrapper for `workflow.getState(status)`).
 *
 * Handles possible old `rootNode` values when Workflow gets renamed.
 */
function getStateNodeByStatus(status, workflow) {
    const taskStatus = getStatusPath(status, workflow);
    return workflow && typeof taskStatus === 'string'
        ? workflow.getState(taskStatus)
        : undefined;
}
exports.getStateNodeByStatus = getStateNodeByStatus;
// useMemo wrapper for getStateNodeByStatus
function useStateNodeByStatus(status, workflow) {
    return (0, react_1.useMemo)(() => {
        return getStateNodeByStatus(status, workflow);
    }, [status, workflow]);
}
exports.useStateNodeByStatus = useStateNodeByStatus;
//# sourceMappingURL=useStateNodeByStatus.js.map